import actionTypes from '../constants/actionTypes/text-action-types';
import { asyncReducerFactory } from 'gje-redux-async';

export default asyncReducerFactory({ actionTypes, initialDataValue: {} });
